export const signupMainSx = {
  alignItems: 'stretch',
  minHeight: { md: '70vh' },
  width: '100%',
};

export const signupLeftSx = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  py: { xs: 2, md: 4 },
  minWidth: 0,
  '@media (max-width: 514px)': {
    p: 0,
  },
};

export const signupRightSx = {
  background: `linear-gradient(0deg, rgba(255, 255, 255, .7) 0%, rgba(255, 255, 255, .4) 100%), linear-gradient(
    135deg,
    rgba(92, 192, 145, 0.9) 0%,
    rgba(35, 181, 195, 0.4) 100%
  ),
  repeating-linear-gradient(
    45deg,
    #eee,
    #eee 40px,
    #fff 40px,
    #fff 80px
  )`,
  display: { xs: 'none', md: 'flex' },
  alignItems: 'center',
  justifyContent: 'center',
  py: 4,
  px: { md: 3, lg: 6 },
  boxSizing: 'border-box',
  minWidth: 0,
};

export const signupBulletsSx = {
  p: 0,
  pt: 3,
  m: 0,
  listStyle: 'none',
  textAlign: 'left',
  width: '100%',
};

export const signupBulletSx = {
  position: 'relative',
  pl: '10px',
  mb: 4,
  '&:last-child': {
    mb: 0,
  },
};

export const signupBulletIconSx = {
  display: 'inline-block',
  verticalAlign: 'middle',
  color: 'rgb(35, 181, 195)',
  fontSize: 24,
  position: 'absolute',
  top: '25px',
};

export const signupBulletTextSx = {
  display: 'block',
  ml: '40px',
  '& h2': {
    mb: 0,
    fontWeight: 800,
    fontSize: { md: '1.15rem', lg: '1.35rem' },
    lineHeight: 1.3,
    wordWrap: 'break-word',
  },
  '& p': {
    mt: 1,
    mb: 0,
    lineHeight: 1.5,
    wordWrap: 'break-word',
  },
};
